// @flow
import DiamondSpecTable from '@components/productDetail/DiamondSpecTable';

import LinkPopup from '@components/popups/Link';
import * as ColorContent from '@components/popups/content/Color';

const colors = [
  {
    symbol: 'D',
    descriptions: [
      'This D color diamond is absolutely colorless, the highest grade possible.  Only 10% of jewelry quality diamonds are D in color. The complete lack of body color allows reflected light to display in true and brilliant color.'
    ]
  },
  {
    symbol: 'E',
    descriptions: [
      'This E color diamond appears colorless to the naked eye.  Only when examined in a special environment by a trained observer would any difference between a D and an E color diamond be detected.'
    ]
  },
  {
    symbol: 'F',
    descriptions: [
      'This F color diamond appears colorless to the untrained observer.  F color is the least expensive diamond color in the GIA colorless range, typically selling for 10-25% less than a comparable D color diamond.'
    ]
  },
  {
    symbol: 'G',
    descriptions: [
      'This G color diamond is near colorless, the highest GIA grade for diamonds with any trace of color.  Appearing colorless to the casual observer, G color diamonds usually sell for 15-35% less than a comparable D color diamond.'
    ]
  },
  {
    symbol: 'H',
    descriptions: [
      'This H color diamond is near colorless, the very slight tint is not noticeable once the diamond is set in a ring.  A great value for those seeking a colorless appearance, but unwilling to pay a premium for something not easily seen.'
    ]
  },
  {
    symbol: 'I',
    descriptions: [
      'This I color diamond will produce a slightly warmer glow than higher grades, especially in sizes over 1.50 carat.  If the diamond has Medium or higher fluorescence, it may appear whiter than a typical I color diamond.'
    ]
  },
  {
    symbol: 'J',
    descriptions: [
      'This J color diamond is ideally set in yellow gold in order to complement its slight body color.  J color diamonds are an exceptional value, usually selling for 20-40% less than a comparable G color diamond.'
    ]
  },
  {
    symbol: 'K',
    descriptions: [
      'This K color diamond is the highest rated of the GIA faint color range.  Beginning with K color diamonds, color is more easily detected by the naked eye.  If Medium or higher fluorescence is present, it may appear slightly whiter.'
    ]
  },
  {
    symbol: 'L',
    descriptions: [
      'This L color diamond will have an easily detectable body color, and should only be set in yellow gold.  L color diamonds typically sell for 25-45% less than a diamond from the next higher GIA color range (G-J).'
    ]
  },
  {
    symbol: 'M',
    descriptions: [
      'This M color diamond is the least expensive color from the GIA Faint Color range, usually selling for 25% less than a comparable K color diamond.  If Medium or higher fluorescence is present, it may appear slightly whiter.'
    ]
  }
];

const Popup = ({ children, className, style = {} }) => (
  <LinkPopup initialContent={ColorContent} className={className} style={style}>
    {children}
  </LinkPopup>
);

class DiamondColorTable extends React.Component<{ color: string }> {
  render() {
    const idx = colors.map(c => c.symbol).indexOf(this.props.color);
    return (
      <DiamondSpecTable
        index={idx}
        spec={'color'}
        items={colors}
        Popup={Popup}
      />
    );
  }
}

export default DiamondColorTable;
